export function normalizeRouteRefPath(path: string): string {
  return path.replace(/\/\*(?=\/|$)/g, '');
}
